// The saved town was renamed while its partially saved draft was still open.
// Migrate its remaining text without changing draft IDs or save progress.
const oldTownName = 'Eastern Khazil Waytown';
export const normalizePlaceTreeNames = (value, key = '') => {
  if (Array.isArray(value)) return value.map(entry => normalizePlaceTreeNames(entry, key));
  if (value && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).map(([field, entry]) =>
      [field, normalizePlaceTreeNames(entry, field)]));
  }
  if (typeof value !== 'string' || !value.includes(oldTownName) || /(?:id|ids|key|keys)$/i.test(key)) return value;
  // Signatures and event details can contain serialized records with identity fields.
  if (value.startsWith('[') || value.startsWith('{')) {
    try { return JSON.stringify(normalizePlaceTreeNames(JSON.parse(value))); } catch { /* Plain text. */ }
  }
  return value.split(oldTownName).join('Harolton');
};
